module.exports = __webpack_public_path__ + "img/picture.5947df45.png";